// services/everpro/everpro-order/create.ts - services/everpro/everpro-order.ts split (sub-module create)

import { withRetry } from '../../../utils/retryLogic';
import { everproFetch } from '../everpro-auth';
import type { CreateEverproOrderParams, CreateEverproOrderResult } from '../everpro-types';
import { buildCreateOrderBody } from './createBody.js';


export async function createEverproOrder(params: CreateEverproOrderParams, brandId: string): Promise<CreateEverproOrderResult> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  const body = buildCreateOrderBody(params);

  console.log('[Everpro] Creating order:', params.clientOrderNo, '| pickup_time (unix):', body.pickup_time, '| pickup_time (str):', new Date(body.pickup_time).toISOString());
  console.log('[Everpro] Sign key fields sent:', {
    shipper_postal_code: body.shipper_postal_code,
    receiver_postal_code: body.receiver_postal_code,
    height: body.height,
    width: body.width,
    length: body.length,
    package_type_id: body.package_type_id,
    is_use_insurance: body.is_use_insurance,
    shipment_price: body.shipment_price,
    cod_price: body.cod_price,
    min_duration: body.min_duration,
    max_duration: body.max_duration,
    is_flat_rate: body.is_flat_rate,
    signed_key: body.signed_key,
  });

  console.log('[Everpro] Create order full body:', JSON.stringify(body, null, 2));

  const res = await withRetry(() => everproFetch(brandId, '/shipment/v2/orders', {
    method: 'POST',
    body: JSON.stringify(body),
  }), {
    maxRetries: 2,
    initialDelayMs: 1000,
    backoffMultiplier: 2,
    shouldRetry: (err) => {
      if (err instanceof TypeError) return true;
      return false;
    },
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    console.error('[Everpro] Create order error:', res.status, detail);
    // 504 = timeout, BUKAN pasti gagal: order bisa sudah tercipta di Everpro.
    // Booking single/bulk otomatis cek by clientOrderNo sebelum create ulang
    // (guard anti double di bookShipment.ts/booking.ts) — aman tekan booking lagi.
    if (res.status === 504) {
      throw new Error(message || 'Everpro timeout (504) — order mungkin sudah tercipta. Booking ulang aman: sistem cek duplikat otomatis sebelum membuat order baru.');
    }
    throw new Error(message || `Everpro create order: ${res.status} ${res.statusText}`);
  }

  const json = await res.json();
  const data = json?.data ?? {};
  return {
    clientOrderNo: data.client_order_no ?? params.clientOrderNo,
    shipmentOrderNo: data.shipment_order_no,
    actualPrice: data.actual_price,
    actualCodPrice: data.actual_cod_price,
  };
}
